import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-import-btn',
  templateUrl: './import-btn.component.html',
  styleUrls: ['./import-btn.component.scss']
})
export class ImportBtnComponent  {
  @Input() label = 'Import'
}
